import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import MajorAssignments from "./pages/MajorAssignments";
import ScrollToTop from "@/components/ScrollToTop";
import Services from "./pages/Services";
import Process from "./pages/Process";
import PriceTrends from "./pages/PriceTrends";
import Certificates from "./pages/Certificates";
import Contact from "./pages/Contact";

function App() {
  return (
    <div className="App">
      <div
        className="site-watermark"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/MehtaAssociatesLogo.png)`,
        }}
        aria-hidden="true"
      />
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/major-assignments" element={<MajorAssignments />} />
          <Route path="/services" element={<Services />} />
          <Route path="/process" element={<Process />} />
          {/* <Route path="/price-trends" element={<PriceTrends />} /> */}
          <Route path="/certificates" element={<Certificates />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
